module.exports = __webpack_public_path__ + "img/65d20ac19386ece8458b17558d85aaa2.png";